/**
 * King Living: FullMediaCarouselFragment — minimal complexity for Contentful (max ~11k cost).
 * Do NOT use SectionPanelFragment / RichTextBlockFragment / ImageFragment here: they nest
 * contentCollection or rich-text links and explode query cost. Use Base* only; refetch full
 * entry by id in the app when a slide needs deeper data.
 */

import gql from 'graphql-tag';

import {CarouselItemFragment} from '@amblique/contentful/app/contentful/fragments/carousel-item/carousel-item.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseMediaCarouselFragment} from '@amblique/contentful/app/contentful/fragments/media-carousel/base-media-carousel.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {BaseSectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/base-section-panel.fragment';
import {BaseShopTheLookFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look/base-shop-the-look.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const FullMediaCarouselFragment = gql`
  ${BaseMediaCarouselFragment}
  ${CarouselItemFragment}
  ${BaseImageFragment}
  ${BaseRichTextBlockFragment}
  ${BaseSectionPanelFragment}
  ${BaseShopTheLookFragment}
  ${BaseVideoFragment}

  fragment FullMediaCarouselFragment on MediaCarousel {
    ...BaseMediaCarouselFragment

    imagesCollection(limit: 25) {
      items {
        __typename
        ... on CarouselItem {
          ...CarouselItemFragment
        }
        ... on Image {
          ...BaseImageFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
        ... on Video {
          ...BaseVideoFragment
        }
        ... on ShopTheLook {
          ...BaseShopTheLookFragment
        }
      }
    }
    thumbnailsCollection(limit: 25) {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
        ... on Video {
          ...BaseVideoFragment
        }
      }
    }
  }
`;
